import React, { useEffect, useRef, useState } from 'react'
import GuestLayout from '../layout/guestLayout'
import { CallWithOutAuth } from "../action/apiActions";
import { showToast } from "../util/toastHelper";
import { ADMIN_ALL_CMS } from "../action/apiPath";
import Loading from "react-fullscreen-loading";

export default function Services() {

   const type = "services";
     const [isLoading, setIsLoading] = useState(true);
     const [fetchData, setfetchData] = useState({});
  
   React.useEffect(() => {
      getData();
    },[]
  );

  const getData = async () => {
    try {
      setIsLoading(true);
      const response = await CallWithOutAuth("GET", `${ADMIN_ALL_CMS}/${type}`);
      if (response.res.status == 200) {
        console.log(response.res?.data?.data);
          setfetchData(response?.res?.data?.data);
          // console.log('setfetchData', fetchData);
      } else {
        showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };
  return (
    <GuestLayout>
    {isLoading && (
            <Loading
              loading
              background="rgba(236, 240, 241, 0.7)"
              loaderColor="#3498db"
            />
          )}
      <section class="from_our_desk">
        <div class="site_container">
          <div class="site_row">
            <div class="txt_colm">
              <div class="txt_block" dangerouslySetInnerHTML={{ __html: fetchData?.content }}>
                {/* <h1>The Evolution of Medicine: A Journey Through Time</h1>
                <p>Medicine has come a long way from its ancient roots to the highly advanced science we know today. This article explores the evolution of medicine, highlighting key milestones, innovations, and the future of healthcare.


                  The fall of the Roman Empire led to a stagnation in medical advancements in Europe, while the Islamic Golden Age saw significant progress in medicine. Scholars like Avicenna wrote influential texts such as "The Canon of Medicine," which synthesized knowledge from various cultures.

                  The Renaissance sparked a revival in scientific inquiry. Anatomists like Andreas Vesalius challenged Galenic principles through detailed human dissections, laying the groundwork for modern anatomy.</p>


                <h1>The Age of Enlightenment and Modern Medicine</h1> */}

              </div>
            </div>
            <div class="img_colm">
              <div class="img_block no-img">
                <div class="block_inner">
                <img src={fetchData?.image} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </GuestLayout>
  )
}
